import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Cached admin-role check — shared across every component that mounts the hook,
 * so the `has_role` RPC only runs once per session instead of on each mount.
 */
export function useAdminRole() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['admin-role', user?.id],
    enabled: !!user,
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('has_role', {
        _user_id: user!.id,
        _role: 'admin',
      });
      if (error) return false;
      return !!data;
    },
  });

  return { isAdmin: !!data, loading: !!user && isLoading };
}
